import Vue from 'vue'
import store from './store'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Eula from './views/Eula.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/eula',
      name: 'eula',
      component: Eula,
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('./views/Profile.vue'),
    },
    {
      path: '/user/:userId',
      name: 'userProfile',
      component: () => import('./views/Profile.vue'),
    },
    {
      path: '/landing',
      name: 'landing',
      component: () => import('./views/Landing.vue'),
    },
    {
      path: '/company/:companyId',
      name: 'company',
      component: () => import('./views/Company.vue'),
    },
    {
      path: '/logout',
      name: 'logout',
      // route level code-splitting
      // this generates a separate chunk (logout.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Logout.vue'),
    },
    {
      path: '/change_password',
      name: 'changepassword',
      component: () => import('./views/ChangePassword.vue'),
    }
  ]
})

router.beforeEach((to, _, next) => {
  const authNotRequired = ['home']
  const eulaNotRequired = ['home', 'login', 'logout', 'eula']
  const isLoggedIn = store.getters.isLoggedIn
  const hasAcceptedEula = store.getters.hasAcceptedEula

  // Are they even logged in? No, redirect them.
  // Make sure we put the token where it goes before we try to check if they're logged in
  store.dispatch('persistLogin')
  if (!authNotRequired.includes(to.name) && !isLoggedIn) {
    // If they're not logged in and trying to go somewhere other than login, send them to login
    next({ name: 'home' })
  } else if (!eulaNotRequired.includes(to.name) && isLoggedIn && !hasAcceptedEula) {
    // If they're logged in and have not accepted the eula, send them to the eula page
    next({ name: 'eula' })
  } else if (isLoggedIn && hasAcceptedEula && to.name === 'home') {
    // If they're logged in trying to get to the login page, send them to the landing
    next({ name: 'landing' })
  } else {
    // otherwise send them on their way
    next()
  }
})

export default router;
